import { useSelector } from "react-redux";
import IconComponent from "@CubeComponents/icons";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import { RootState } from "@Reducers/index";

function RightSidebarFileExp({ handleAccordionStateUpdate }: any) {
  const layout = useSelector((state: RootState) => state.layout);

  const iconButton = (action: any, name: any, toolTipContent: any) => (
    <ButtonComponent
      className="mt-6 cursor-pointer bg-transparent border-none p-0 focus:outline-none"
      buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
      onClick={() => handleAccordionStateUpdate(action)}
      data-testid="footerAcknowledgeBtn"
    >
      <IconComponent name={name} toolTipContent={toolTipContent} width="1.5rem" height="1.5rem" />
    </ButtonComponent>
  );

  return (
    <div className="px-3 flex flex-col justify-start items-center bg-surface_white">
      {iconButton("openDetails", "details", "Details")}
      {iconButton("openCustomMetadata", "CustomMetadata", "Templates")}
      {iconButton("openAccess", "access", "Access")}
      {iconButton("openSharing", "Transmittals", "Transmittals")}
      {iconButton("openVersion", "VersionsIcon", "Versions")}
      {iconButton("openDependency", "DependenciesIcon", "Dependencies")}
      {layout.FILE_PROPERTIES?.REVISION?.ENABLE && iconButton("openRevision", "RevisionsIcon", "Revisions")}
    </div>
  );
}

export default RightSidebarFileExp;
